// Known intervals that can be returned for Payment Plans from the Sepio API
export enum SepioPaymentPlanInterval {
	Year = 'year',
	Month = 'month',
}
